import { useContext } from "react";
import { GridStateContext } from "../index";

const useGridState = () => useContext(GridStateContext);

export default useGridState;
